import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../components/navbar'
import Axios from 'axios'
import { RollLight } from 'tsparticles/Options/Classes/Particles/Roll/RollLight'
import Notifications, { notify } from 'react-notify-toast'
import { ZIndex } from 'tsparticles/Options/Classes/Particles/ZIndex/ZIndex'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

const Jobrole = () => {
  const id = useParams().id
  const [job, setJob] = useState({})
  const [application, setApplication] = useState({})
  const navigate = useNavigate()
  const notyf = new Notyf()
  useEffect(() => {
    const fetchJobDetails = async () => {
      await Axios.get(
        'https://hrms-server.rean.in/hr/recruitment-details/' + id
      )
        .then(({ data }) => {
          console.log(data.jobDetails[0])
          if (data.status == 200) {
            setJob(data.jobDetails[0])
            setApplication({
              ...application,
              positionTitle: data.jobDetails[0].positionTitle,
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }

    fetchJobDetails()
  }, [])

  const submitApplication = async () => {
    console.log(application)
    if (
      !application.name ||
      !application.email ||
      !application.experience ||
      !application.linkedinProfile ||
      !application.currentEmployer ||
      !application.resume ||
      !application.ctc ||
      !application.mobileNumber
    ) {
      notyf.error('Please fill all required fields!')
    } else if (!validateEmail(application.email)) {
      notyf.error('Invalid email!')
    } else {
      await Axios.post(
        'https://hrms-server.rean.in/hr/recruitment-entry',
        application
      )
        .then(({ data }) => {
          console.log(data)
          if (data.status == 200) {
            setTimeout(() => {
              // setIsLoading(false);
              navigate('/careers')
            }, 1800)
            notyf.success(
              'Your application has been submitted! You will receive an email for the same.'
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  const handleInpChange = (event) => {
    setApplication({
      ...application,
      [event.target.name]: event.target.value,
    })
  }
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }
  const resumeChange = (e) => {
    const reader = new FileReader()
    reader.onload = () => {
      setApplication({
        ...application,
        resume: reader.result,
      })
    }
    reader.readAsDataURL(e.target.files[0])
  }

  return (
    <>
      {job.positionTitle == undefined ? (
        ''
      ) : (
        <div className='section-nav jobrole'>
          <Navbar />
          <div className='jobrole-container'>
            <div className='container'>
              <div className='heading'>{job.positionTitle}</div>
              <div className='row'>
                <div className='col-md-6 details'>
                  <div className='jobrole-container-row'>
                    <div className='info'>
                      <div className='info-head'>Location</div>
                      <div className='info-desc'>{job.location}</div>
                    </div>

                    <div className='info'>
                      <div className='info-head'>Responsibilities</div>
                      <div className='info-desc'>
                        {job.responsibilities.map((resp) => {
                          return <li>{resp}</li>
                        })}
                      </div>
                    </div>

                    <div className='info'>
                      <div className='info-head'>Qualifications</div>
                      <div className='info-desc'>{job.qualification}</div>
                    </div>

                    <div className='info'>
                      <div className='info-head'>Experience</div>
                      <div className='info-desc'>{job.experience}</div>
                    </div>

                    <div className='apply'>
                      {/* <Link to={`/`} target='_blank'>
                        <button className='btn btn-theme-careers'>
                          Apply Now
                        </button>
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className='col-md-6 form'>
                  <div className='form'>
                    <div className='input'>
                      <label class='form-label'>
                        Full Name <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        onChange={handleInpChange}
                        name='name'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Email Address <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='email'
                        onChange={handleInpChange}
                        name='email'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Phone Number <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='number'
                        onChange={handleInpChange}
                        name='mobileNumber'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        How many years of professional experience do you have?{' '}
                        <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='number'
                        onChange={handleInpChange}
                        name='experience'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Current Employer <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        onChange={handleInpChange}
                        name='currentEmployer'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Current CTC <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        onChange={handleInpChange}
                        name='ctc'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Linkedin Profile <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        onChange={handleInpChange}
                        name='linkedinProfile'
                        class='form-control'
                      />
                    </div>

                    <div className='input'>
                      <label class='form-label'>
                        Resume <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='file'
                        onChange={resumeChange}
                        name='resume'
                        class='form-control'
                        accept='application/pdf'
                      />
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <label class='form-label' style={{ fontSize: '14px' }}>
                        <span className='text-danger'>*</span> Choose PDF file
                        only
                      </label>
                    </div>

                    <div className='btn btn-theme' onClick={submitApplication}>
                      Submit Application
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Jobrole
